// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"nopUwtPJlBAnNH17LDSxo"};